const lang = {
  intro: {
    title: 'Savourez votre prochaine',
    standfirst: 'expérience gastronomique',
    paragraph:
      '<p>Une fois inscrit, votre bénéfice Dining vous permettra de profiter d’un crédit pouvant aller jusqu’à 200 € par an, à dépenser dans notre sélection de plus de 200 restaurants triés sur le volet et présentés ici. Profitez de 100€ à dépenser de janvier à juin et 100€ supplémentaires à dépenser de juillet à décembre.</p>',
    creditCards: [
      {
        header: 'Crédit de 200 € à utiliser en <strong>France</strong>',
        credits: [
          {
            amount: 'Crédit dining de 100 €',
            period: 'De janvier à juin',
          },
          {
            amount: 'Crédit dining de 100 €',
            period: 'De juillet à décembre',
          },
        ],
      },
    ],
    tcLink: 'Voir les détails et Conditions générales du bénéfice dining',
    topBanner: {
      show: false,
      heading:
        'Bonne nouvelle ! Votre crédit dining sera renouvelé en janvier 2025.',
      description:
        'Votre inscription actuelle se termine le 31 décembre 2024, mais des informations sur la façon de vous réinscrire vous seront communiquées.',
    },
    hotelRestaurant: '',
  },
  filters: {
    country: 'Pays :',
    state: 'State :',
    stateDefault: 'All states',
    city: 'Ville:',
    cityDefault: 'Toutes les villes',
    cuisine: 'Cuisine:',
    cuisineDefault: 'Type de cuisine',
    search: 'Rechercher un restaurant:',
    searchPlaceholder: 'Saisissez au moins 3 caractères...',
    postalCode: 'Votre code postal :',
    postalCodePlaceholder: 'Entrez le code postal',
    postalCodeInvalid: 'Format de code postal invalide',
    sortBy: 'Trier par',
    alphabetical: 'Alphabétique',
    nearest: 'Plus proche :',
    clear: 'Effacer',
    refineTitle: 'Affiner votre recherche',
    refineSubtitle: 'Filtrer les restaurants par lieu ou type de cuisine',
    filterModalHeading: 'Filtrer les restaurants',
    cancel: 'Annuler',
    confirm: 'Confirmer',
  },
  results: {
    halal: 'Halal',
    michelin: 'Michelin',
    notAvailable: 'Aucun restaurant ne correspond à votre recherche.',
    viewmap: 'Voir sur la carte',
    makebooking: 'Pour réserver, rendez-vous sur :',
    makebookingTel: 'Pour réserver par téléphone :',
    orderOnline: 'Pour commander, veuillez consulter le site :',
    deliveryTakeaway: 'Emporter / livraison disponible',
    deliveryProvidoor: 'Delivery available via Providoor',
    openingSoon: 'Opening soon',
    onlineOnly: 'Online Only',
    new: 'Nouveau',
    locations: 'Lieux',
    button: 'Cliquez pour voir les lieux',
    groupCuisine: 'Types de cuisines variés',
    close: 'Fermer',
    bookNow: 'Réserver maintenant',
  },
  tsAndCs: {
    title: "CONDITIONS DE L'OFFRE ",
    platinum: {
      html: `<ul><li><strong>Le montant maximum de remboursement est de 100€ tous les 6 mois par année civile</strong>:  le bénéfice se renouvellera au 1er janvier et au 1er juillet jusqu'à la date de fin du bénéfice au 31/12/2026. Vous ne pouvez pas reporter la valeur inutilisée du bénéfice sur la période suivante. Si vous dépensez le dernier jour d'une période, votre transaction risque de ne pas être capturée, il est donc recommandé d'effectuer l’achat au moins 1 jour avant la fin de la période.  </li><li><strong>Carte principale uniquement</strong>: Le bénéfice est éligible uniquement aux titulaires de la Carte principale Platinum American Express. Les opérations effectuées avec une Carte supplémentaire ne sont pas éligibles à ce bénéfice.  </li><li><strong>Inscrivez-vous au bénéfice</strong>: Vous devez d'abord enregistrer le bénéfice sur votre Carte Platinum avant d'effectuer votre paiement pour être éligible à celui-ci. Si vous utilisez une autre carte pour effectuer un paiement à tout moment, vous ne serez pas éligible au bénéfice.  </li><li><strong>Transactions éligibles</strong>: Bénéfice valable uniquement pour les services de restauration sur place effectués en personne dans un restaurant participant en France. La liste complète des restaurants participants se trouve ici. La liste des restaurants participants peut être modifiée sans préavis, veuillez la vérifier avant de dîner car vous ne serez pas éligible à recevoir le crédit si le restaurant ne figure pas sur la liste au moment de votre transaction.  </li><li><strong>Transactions exclues</strong>: Le bénéfice exclut les achats de cartes-cadeaux et de bons d'achat, les dépôts facturés par les restaurants en amont de la réservation, les frais de réservation, d'annulation et de non-présentation, les services de vente à emporter ou de repas à domicile.</li><li><strong>Paiements directs uniquement</strong>: Si vous payez à l'aide d’un agrégateur de paiement tels que le paiement par QR code, ou via  l'application d'un restaurant, vous n'êtes peut-être pas éligible au bénéfice. Veuillez demander à payer en direct. </li><li><strong>Attribution du crédit</strong>: Les crédits doivent apparaître sur votre relevé de facturation dans les 30 jours suivant la date du paiement, mais peuvent prendre plus de temps. Veuillez contacter le service client si vous ne recevez pas votre crédit. Les crédits ne sont pas échangeables contre de l'espèce ou toute autre mode de paiement. </li><li><strong>Expiration ou retrait du bénéfice</strong>: Le bénéfice expirera le 31/12/2026. American Express peut vous retirer le bénéfice à tout moment en vous donnant un préavis de 60 jours. </li><li><strong>Votre utilisation des restaurants participants</strong>: Votre achat de biens et/ou de services auprès des restaurants participants est régi par leurs conditions générales respectives (y compris les politiques de confidentialité). American Express n'est nullement responsable des biens et/ou services des restaurants participants. Les demandes de renseignements ou les plaintes relatives aux produits et/ou services des restaurants participants doivent être adressées à leur service clientèle. </li><li><strong>Nos conditions générales des Offres</strong>: Nos conditions générales des Offres s'appliquent également à ce bénéfice et contiennent des conditions supplémentaires importantes.  </li></ul>`,
    },
    close: 'Fermer',
  },
  pocket: {
    title: 'Explore 800+ restaurants and book directly with Pocket Concierge',
    button: 'Visit Pocket Concierge',
  },
  pocketCard: {
    title: 'Pocket Concierge',
    description:
      'Découvrez et réservez auprès des meilleurs restaurants au Japon (seuls les restaurants qui acceptent les prépaiements sont éligibles)',
    cuisines: 'Types de cuisines variés',
    instruction: 'Pour réserver, rendez-vous sur :',
    button: 'Visit Pocket Concierge',
  },
  footer: {
    disclaimer: `<p>* Veuillez noter que si vous séjournez dans un hôtel, ce crédit ne sera appliqué que lors du règlement de la facture du restaurant directement avec le restaurateur, séparément du paiement global de l’hôtel.</p><p>Une inscription est requise via la rubrique "Offres" dans votre espace client en ligne ou via l'application American Express®. Les détails du bénéfice peuvent être consultés dans les conditions générales de celui-ci lors de l'inscription.</p><ul><li><a href='https://www.americanexpress.com/fr-fr/societes/legale/centre-de-confidentialite/'>Centre de confidentialité</a></li><li><a href='https://www.americanexpress.com/fr-fr/societes/legale/centre-de-confidentialite/a-propos-des-Cookies/'>Politique de gestion des Cookies</a></li></ul><p>Copyright © 2026 American Express Company</p>`,
  },
  platinumBanner: {
    title: 'Tous les bénéfices de votre Carte Platinum',
    text: 'Re-découvrez tous les bénéfices de votre Carte Platinum : pour vos voyages (longs et courts séjours), vos assurances, vos évènements, et bien plus encore. Des avantages conçus spécifiquement pour nos titulaires Platinum.',
    button: 'Re-découvrez tous les bénéfices de votre Carte Platinum',
  },
}

export default lang
